const formatAddress = (address) => {
  const normalized = {};

  const COMPONENT_TYPE_MAP = {
    subpremise: 'subpremise',
    street_number: 'streetNumber',
    route: 'route',
    locality: 'locality',
    administrative_area_level_1: 'administrativeArea',
    sublocality_level_1: 'sublocality',
    country: 'regionCode',
    postal_code: 'postalCode',
  };

  address['address_components'].forEach((component) => {
    const componentType = component.types.find((type) =>
      Object.keys(COMPONENT_TYPE_MAP).includes(type)
    );

    if (componentType === 'street_number') {
      normalized.streetNumber = component.long_name;
      normalized.addressLine1 = component.long_name;
    } else if (componentType === 'route') {
      normalized.route = component.long_name;
      if (normalized.addressLine1) {
        normalized.addressLine1 += ` ${component.long_name}`;
      } else {
        normalized.addressLine1 = component.long_name;
      }
    } else if (componentType) {
      const type = COMPONENT_TYPE_MAP[componentType];
      normalized[type] = component.short_name;
    }
  });

  if (normalized.subpremise) {
    normalized.addressLine1 = `${normalized.addressLine1} ${normalized.subpremise}`;
  }

  normalized.languageCode = 'EN_AU';

  const formattedAddress = {
    ...normalized,
    formattedPlace: address.formattedPlace,
    formatted_address: address.formatted_address,
  };

  return formattedAddress;
};

export { formatAddress };
